/**
 * @generated SignedSource<<c105fb8397e186aa1907db3cb4a00d61>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type TestOrderDetailInput = {
  attributes?: ReadonlyArray<TestOrderAttributeInput> | null;
  designModificationID?: any | null;
  quantity: number;
};
export type TestOrderAttributeInput = {
  id: string;
  valueId: string;
};
export type testPageOrderMutation$variables = {
  compositionDocID?: string | null;
  designDocID?: string | null;
  details?: ReadonlyArray<TestOrderDetailInput> | null;
};
export type testPageOrderMutation$data = {
  readonly createTestOrder: {
    readonly orderID: number;
  };
};
export type testPageOrderMutation = {
  response: testPageOrderMutation$data;
  variables: testPageOrderMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "compositionDocID"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "designDocID"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "details"
},
v3 = [
  {
    "kind": "Variable",
    "name": "compositionDocID",
    "variableName": "compositionDocID"
  },
  {
    "kind": "Variable",
    "name": "designDocID",
    "variableName": "designDocID"
  },
  {
    "kind": "Variable",
    "name": "details",
    "variableName": "details"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "orderID",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/),
      (v2/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "testPageOrderMutation",
    "selections": [
      {
        "alias": null,
        "args": (v3/*:: as any*/),
        "concreteType": "Order",
        "kind": "LinkedField",
        "name": "createTestOrder",
        "plural": false,
        "selections": [
          (v4/*:: as any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*:: as any*/),
      (v0/*:: as any*/),
      (v2/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "testPageOrderMutation",
    "selections": [
      {
        "alias": null,
        "args": (v3/*:: as any*/),
        "concreteType": "Order",
        "kind": "LinkedField",
        "name": "createTestOrder",
        "plural": false,
        "selections": [
          (v4/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "1b60b5b6c5a34eb970385db13fa303da",
    "id": null,
    "metadata": {},
    "name": "testPageOrderMutation",
    "operationKind": "mutation",
    "text": "mutation testPageOrderMutation(\n  $designDocID: String\n  $compositionDocID: String\n  $details: [TestOrderDetailInput!]\n) {\n  createTestOrder(designDocID: $designDocID, compositionDocID: $compositionDocID, details: $details) {\n    orderID\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "ffefa05aa8b068135022da5e1e09f89d";

export default node;
